<script>
	export let code;
	export let graph;
	export let price;
	export let evo;

</script>


<div class="flex-container">

	<div class="flex-item">
		<h2 class="code">{code}</h2>
	</div>

	<div class="flex-item">
		<h2 class="price">
			{#if price > 100}
				{Math.floor(price)?.toLocaleString('fr')}
			{:else}
				{price?.toLocaleString('fr')}
			{/if}
		</h2>
	</div>

	<a 
		class="flex-item evo"
		class:evo_pos="{evo > 0}"
		class:evo_neg="{evo < 0}"
		style="--graph: url({graph});"
		href={"/graph.html?symbol="+code+"usd"}
		target="_blank"
		rel="noopener noreferrer"
	>
		{#if evo > 0}
			&uarr;{evo}%
		{:else}
			&darr;{Math.abs(evo)}%
		{/if}
	</a>

	

</div>

<!-- <div 
	class="flex-item graph"
	style="--graph: url({graph});"
>
	<h2>&nbsp;</h2>
</div> -->

<style>
	h2 {
		text-transform: uppercase;
		font-size: 2rem;
		font-weight: 200;
		display: inline;
	}

	.code {
		color: #fa0a;
	}

	.price {
		color: #eee;
	}

	.flex-container {
		max-width: 600px;
		margin: 3rem auto;
		display: flex;
		justify-content: space-between;
		align-items: center;
		flex-wrap: nowrap;
	}

	.flex-item {
		flex-grow: 1;
		flex-shrink: 0;
		flex-basis: 0;
	}

	.evo {
		font-size: 1.25rem;
		font-weight: 200;
		text-decoration: none;
		display: inline;
		position: relative;
		align-self: stretch;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		color: #fff0;
	}

	.evo::before {
		content: "";
		position: absolute;
		top: 0; 
		left: 0;
		width: 100%; 
		height: 100%;
		background-image: var(--graph);
		background-repeat: no-repeat; 
		background-size: contain;
		background-position: center;
		filter: grayscale(1);
		opacity: 0.2;
		z-index: -1;
	}

	.evo_pos {
		color: #0a0;
	}

	.evo_neg {
		color : #c00;
	}

</style>